import { useState } from "react";
import { Box, IconButton } from "@mui/material";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import ZoomInRoundedIcon from "@mui/icons-material/ZoomInRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Modal from "components/Modal";

// S3 links carry a query string, so look at the path only.
const isPdfSource = (src = "", name = "") =>
  /\.pdf$/i.test(String(name)) || /\.pdf$/i.test(String(src).split("?")[0]);

export const FilePreview = ({ src, name, isPdf, size = 56, label = "View full-size preview" }) => {
  const [open, setOpen] = useState(false);
  const pdf = isPdf ?? isPdfSource(src, name);

  return (
    <>
      <Box
        component="button"
        type="button"
        onClick={() => setOpen(true)}
        aria-label={label}
        title={name || label}
        sx={{
          position: "relative",
          flexShrink: 0,
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: "8px",
          border: "1px solid var(--border-hairline)",
          overflow: "hidden",
          padding: 0,
          cursor: "pointer",
          background: "var(--healon-scaffold)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&:hover .zoom-overlay": { opacity: 1 },
        }}
      >
        {pdf ? (
          <PictureAsPdfRoundedIcon sx={{ fontSize: `${size * 0.46}px`, color: "var(--brand)" }} />
        ) : src ? (
          <img src={src} alt={name || "Preview"} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        ) : (
          <InsertDriveFileRoundedIcon sx={{ fontSize: `${size * 0.42}px`, color: "var(--text-muted)" }} />
        )}
        <Box
          className="zoom-overlay"
          sx={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.35)", opacity: 0, transition: "opacity 150ms ease" }}
        >
          <ZoomInRoundedIcon sx={{ fontSize: `${size * 0.36}px`, color: "#fff" }} />
        </Box>
      </Box>

      <Modal open={open} handleClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "92vw",
            height: "92vh",
            maxWidth: "1100px",
            outline: "none",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <IconButton
            onClick={() => setOpen(false)}
            aria-label="Close preview"
            sx={{ alignSelf: "flex-end", marginBottom: "8px", background: "#fff", "&:hover": { background: "#fff" } }}
          >
            <CloseRoundedIcon />
          </IconButton>
          {pdf ? (
            <Box component="iframe" src={src} title={name || "Full preview"} sx={{ width: "100%", flex: 1, border: "none", borderRadius: "12px", background: "#fff" }} />
          ) : (
            <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
              <img src={src} alt={name || "Full preview"} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: "12px" }} />
            </Box>
          )}
        </Box>
      </Modal>
    </>
  );
};
